import { Skeleton, Table, Text } from "@chakra-ui/react";
import React from "react";

const AllTradesSkeleton = () => {
  return (
    <Table.ScrollArea
      borderWidth="1px"
      rounded="md"
      maxHeight="70vh"
      width="100%"
    >
      <Table.Root interactive variant="outline" stickyHeader>
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader width="10%">Sr.No.</Table.ColumnHeader>
            <Table.ColumnHeader width="10%" textAlign="center">
              Account No
            </Table.ColumnHeader>
            <Table.ColumnHeader width="15%" textAlign="center">
              Deal No
            </Table.ColumnHeader>
            <Table.ColumnHeader width="10%" textAlign="center">
              Symbol
            </Table.ColumnHeader>
            <Table.ColumnHeader width="8%" textAlign="center">
              B/S
            </Table.ColumnHeader>
            <Table.ColumnHeader width="8%" textAlign="center">
              Qty
            </Table.ColumnHeader>
            <Table.ColumnHeader width="10%" textAlign="center">
              Price
            </Table.ColumnHeader>
            <Table.ColumnHeader width="10%" textAlign="center">
              Profit
            </Table.ColumnHeader>
            <Table.ColumnHeader width="14%" textAlign="center">
              Time
            </Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {Array.from({ length: 10 })?.map((_, index) => (
            <Table.Row key={index}>
              <Table.Cell padding="1rem">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center" fontSize="xs">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </Table.ScrollArea>
  );
};

export default AllTradesSkeleton;